var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('span',{staticClass:"alert",class:_vm.typeClass},[_c('span',{domProps:{"innerHTML":_vm._s(_vm.$t(_vm.text))}}),_c('span',{staticClass:"glyphicon marginal-left-m",class:_vm.icon})])
}
var staticRenderFns = []

export { render, staticRenderFns }